import styled from '@emotion/styled'

import { Color, ComparatorStylesProps, comparatorStyles } from '../../constants'
import { Clickable } from '../Clickable'

export const ComparatorTrigger = styled(Clickable)<ComparatorStylesProps>(
  (props) => ({
    ...comparatorStyles(props),
    width: 'auto',

    '&:hover': {
      color: Color.CHARCOAL,
      backgroundColor: Color.LIGHT_GREY,
    },
  }),
)

ComparatorTrigger.displayName = 'ComparatorTrigger'
